const common = {
  state: {
    showTabBar: true,
    Forecast: '报数起卦',
    forecastResult: '',
    forecastContent: null,
    num1: '',
    num2: ''
  },

  mutations: {
    setShowTabBar: (state, showTabBar) => {
      state.showTabBar = showTabBar
    },
    setForecast: (state, Forecast) => {
      state.Forecast = Forecast
    },
    setForecastResult: (state, forecastResult) => {
      state.forecastResult = forecastResult
    },
    setForecastContent: (state, forecastContent) => {
      state.forecastContent = forecastContent
    },
    setForecastNum: (state, nums) => {
      state.num1 = nums.num1
      state.num2 = nums.num2
    }
  }
}

export default common
